import { useMutation } from 'react-query';
import message from 'antd/es/message';

import {
  convertOfficialHiIdToOriginalId,
  isOfficalAddress,
  queryClient,
  request,
  toastError,
  useCurrentUserId,
} from '@/utils';
import { setOfficialDetail, setUserDetail, useOfficialAccount } from '@/hooks';

import { setQueryFeedAllUsersInList } from '../../hooks';

export const usePinOperateStream = ({
  action,
  articleId,
}: {
  action: 'pin' | 'unpin';
  articleId: number;
}) => {
  const currentId = useCurrentUserId();
  const isPinAction = action === 'pin';
  return useMutation(
    () => {
      const url = isPinAction ? '/article/pin' : '/article/unpin';
      return request.post<{ is_success: boolean }>(url, {
        id: articleId,
      });
    },
    {
      onSuccess(res) {
        if (!res?.is_success) {
          toastError(res);
          return;
        } else {
          message.success(isPinAction ? 'pinned' : 'unpinned');
        }
        const postStreamKey = ['/article/post_list', currentId];
        queryClient.refetchQueries(postStreamKey);
      },
      onError(err: any) {
        toastError(err);
      },
    },
  );
};

export const useMuteOperate = ({
  action,
  userId,
}: {
  action: 'mute' | 'unmute';
  userId: string;
}) => {
  const currentId = useCurrentUserId();
  const isOfficial = isOfficalAddress(userId);
  const originalId = convertOfficialHiIdToOriginalId(userId);
  const { officialAccountDetail } = useOfficialAccount(originalId, { enabled: isOfficial });
  const isMuteAction = action === 'mute';
  return useMutation(
    () => {
      const url = isMuteAction ? '/user/mute' : '/user/unmute';
      return request.post<{ is_success: boolean }>(url, {
        target_id: userId,
      });
    },
    {
      onSuccess(res) {
        if (!res?.is_success) {
          toastError(res);
          return;
        } else {
          message.success(isMuteAction ? 'Muted' : 'Unmuted');
        }

        if (!currentId) {
          return;
        }

        // const listTypes = [LIST_URL.feeds.url, LIST_URL.hot_feeds.url];

        // const handler = (pre: FeedArticleDetail, url: string) => {
        //   if (pre) {
        //     if (listTypes.includes(url)) {
        //       pre.article.is_visible = false;
        //     }
        //   }
        // };
        // if (isMuteAction) {
        //   setQueryAllFeedDetailByUserId({
        //     currentAddress: currentId,
        //     userId,
        //     recipe: handler,
        //   });
        // }

        const userHandler = (pre?: UnionAccount) => {
          if (pre) {
            if (isOfficial) {
              (pre as OfficialAccount).is_muted = !(pre as OfficialAccount).is_muted;
            } else {
              (pre as GeneralAccount).desc.user.is_muted = !(pre as GeneralAccount)?.desc?.user
                ?.is_muted;
            }
          }
        };

        setQueryFeedAllUsersInList(currentId, userId, userHandler);

        // 更新profile
        if (isOfficial) {
          setOfficialDetail({
            currentId,
            officialId: officialAccountDetail?.slug,
            recipe: pre => {
              pre.is_muted = !pre.is_muted;
            },
          });
        } else {
          setUserDetail({
            currentId,
            userId: userId,
            recipe: pre => {
              if (pre.desc) {
                pre.desc.user.is_muted = !pre.desc?.user?.is_muted;
              }
            },
          });
        }
      },
      onError(err: any) {
        toastError(err);
      },
    },
  );
};
